import type { ExperimentDefinition } from './types';
import { validateExperiments } from './validateExperiment';

export const personalAideExperiment = {
  name: 'personal-aide',
  version: 1,
  shipped: process.env.NEXT_PUBLIC_EXP_PERSONAL_AIDE_SHIPPED === 'true',
  enabled: process.env.EXP_PERSONAL_AIDE_ENABLED !== 'false',
  controlVariant: 'off',
  botVariant: 'off',
  targeting: { countries: ['US'], languages: ['en'] },
  variants: {
    off: { ratio: 0.5 },
    on: { ratio: 0.5 },
  },
} as const satisfies ExperimentDefinition;

export const PRODUCTION_EXPERIMENTS: ExperimentDefinition[] = [
  personalAideExperiment,
];

export const ACTIVE_EXPERIMENTS: ExperimentDefinition[] = [
  ...PRODUCTION_EXPERIMENTS,
];

validateExperiments(ACTIVE_EXPERIMENTS);
